import apiClient from './client';
import { buildQueryString } from '../../lib/wallet/utils';

// ── Balance ────────────────────────────────────────────────────────
export const getBalance = (currencyCode) =>
    apiClient.get(`/balance/${currencyCode}`).then((r) => r.data);

export const getAllBalances = (currencyCode) =>
    apiClient.get(`/balance/all/${currencyCode}`).then((r) => r.data);

export const checkBalance = (params) =>
    apiClient.get(`/balance/check${buildQueryString(params)}`).then((r) => r.data);

// ── Wallets ────────────────────────────────────────────────────────
export const listWallets = () =>
    apiClient.get('/list').then((r) => r.data);

// ── Top Up ─────────────────────────────────────────────────────────
export const topUp = (data) =>
    apiClient.post('/topup', data).then((r) => r.data);

// ── Transfer ───────────────────────────────────────────────────────
export const transfer = (data) =>
    apiClient.post('/transfer', data).then((r) => r.data);

// ── Refund ─────────────────────────────────────────────────────────
export const refundTransaction = (data) =>
    apiClient.post('/refund', data).then((r) => r.data);

// ── Transaction History ────────────────────────────────────────────
export const getTransactions = (params) =>
    apiClient.get(`/transactions${buildQueryString(params)}`).then((r) => r.data);

// ── Withdraw ───────────────────────────────────────────────────────
export const withdraw = (data) =>
    apiClient.post('/withdraw', data).then((r) => r.data);

// ── Users ──────────────────────────────────────────────────────────
export const getUsers = (params = {}) =>
    apiClient.get(`/users${buildQueryString(params)}`).then((r) => r.data);

// ── Currencies ─────────────────────────────────────────────────────
export const getCurrencies = () =>
    apiClient.get('/currencies').then((r) => r.data);
